export default "__VITE_PUBLIC_ASSET__1edb9eb6__"